<div class="sm:col-span-1">
  <dt class="text-sm font-medium text-fg-secondary">
    {{ label }}
  </dt>
  <dd class="mt-1 text-sm text-fg-primary">
    {{ value }}
  </dd>
</div>
